export const SUPPORTED_LOCALES = ["en", "pt", "ru", "uk", "uz"];
export const DEFAULT_LOCALE = "en";
export function isAppLocale(value) {
    return SUPPORTED_LOCALES.includes(value);
}
